window.addEventListener("load", function (event) {
  if (document.getElementById('cart-link') !== null && document.getElementById('cart-popup') !== null) {
    const iconCartPopup = document.getElementById('cart-link');
    const cartPopup = document.getElementById('cart-popup');
    updateCartBuble();
    switcherInputQuantityC();

    iconCartPopup.addEventListener('click', function (e) {
      if (!cartPopup.classList.contains('open')) {
        initCartPopup();
        removeBtncartPopUp();
      }
    })
  }
  document.querySelector('.main').addEventListener('click', function (e) {
    if (!e.target.closest('#cart-popup') && document.querySelector('#cart-popup').classList.contains('open') && !document.querySelector('#cart-popup').classList.contains('loading')) {
      document.querySelector('#cart-popup').classList.remove('open')
    }
  })
});


function updateCartItemsCount() {
  fetch(`${window.shopUrl}/cart.js`)
    .then((res) => res.json())
    .then((cart) => {
      const countElement = document.querySelector(".cart-counter .count");
      if (countElement) {
        countElement.textContent = cart.item_count;
      }
    })
    .catch((err) => console.error("Error fetching cart count:", err));
}

function openCartPopup() {
  renderCart();
  document.querySelector('#cart-link').click();
}

function updateCartBuble() {
  var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      return data
    });
  cartContents.then((value) => {
    var cartObject = value;
    if (cartObject.item_count > 0 && document.querySelector('.cart-counter .count') !== null) {
      document.querySelector('.cart-counter .count').textContent = cartObject.item_count;
    }
  });
}

function updateCart(id, q, item) {
  let data = {
    "id": item.dataset.key,
    "quantity": q
  }
  let urlUpdate = window.shopUrl + window.routes.cart_change_url + '.js';
  const cartPopup = document.querySelector('#cart-popup');

  fetch(urlUpdate, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then((data) => {
      if (data.status == 422) {
        item.closest('.cart-popup-product').querySelector('.quantity input').value = q - 1;
        // alert(window.cart_error.available_only.replace('0', q - 1 ));
        cartPopup.classList.remove('loading');
        item.closest('.cart-popup-product').querySelector('.error-quantity').classList.remove('d-none')
        if (window.enabledCurrencySelector) {
          updatePrices();
        }
      } else if (data.status == 400) {
        console.log('Invalid data', data.error)
        cartPopup.classList.remove('loading');
      } else if (data.items_subtotal_price && data.items) {
        renderCart();
        updateCartItemsCount()
        if (window.enabledCurrencySelector) {
          updatePrices();
        }
      } else if (!data.items_subtotal_price) {
        renderCart();
        updateCartItemsCount()
        if (window.enabledCurrencySelector) {
          updatePrices();
        }
        document.querySelector('#cart-popup').classList.remove('open');
        var elMain = document.getElementsByClassName("main");
        if (elMain.length > 0) {
            elMain[0].classList.remove("no-overflow")
        }
      }
    })
    .catch(error => console.error('Error:', error));
}

function initCartPopup() {
  if (document.getElementById('cart-link') !== null && document.getElementById('cart-popup') !== null) {
    const cartPopup = document.getElementById('cart-popup');

    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        return data
      });
    cartContents.then((value) => {
      var cartObject = value;

    });

    cartPopup.querySelectorAll('.cart-popup-product .cart-popup-product-remove-btn button').forEach((item) => {
      item.addEventListener('click', function (e) {
        updateCart(item.dataset.varid, 0, item);
        item.closest('.cart-popup-product').remove();
      })
    })


    removeBtncartPopUp();
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

function renderCart() {
  return fetch(window.shopUrl).then(function (response) {
    if (!response.ok) {
      throw new Error(`Unable to render cart: ${response.status}`);
    }
    return response.text();

  }).then(function (responseText) {
    const doc = new DOMParser().parseFromString(responseText, 'text/html');
    let fetchCartPopup = doc.querySelector('#cart-popup');
    let cartPopup = document.querySelector('#cart-popup');

    if (!fetchCartPopup || !cartPopup) {
      throw new Error('Cart drawer markup was not found.');
    }

    cartPopup.innerHTML = fetchCartPopup.innerHTML;
    switcherInputQuantityC();
    initCartPopup();

    if (window.enabledCurrencySelector) {
      updatePrices();
    }
    cartPopup.classList.remove('loading');
    return true;
  }).catch(function (err) {
    console.error('Something went wrong.', err);
    document.querySelector('#cart-popup')?.classList.remove('loading');
    return false;
  });
}

function removeBtncartPopUp() {
  var cartPopUpElement = document.getElementById("cart-popup");
  var closeCartPopUpBtn = document.getElementById("close-cart-popup");
  var elMain = document.getElementsByClassName("main");

  if (closeCartPopUpBtn) {
    closeCartPopUpBtn.addEventListener("click", function () {
      cartPopUpElement.classList.remove("open")
      if (elMain.length > 0) {
        elMain[0].classList.remove("no-overflow")
      }
    })
  }
}

function switcherInputQuantityC() {
  var quantityContainers = document.querySelectorAll("#cart-popup .quantity");
  quantityContainers.forEach(function (quantityContainer) {
    var minusBtn = quantityContainer.querySelector(".minus");
    var plusBtn = quantityContainer.querySelector(".plus");
    var inputBox = quantityContainer.querySelector(".input-box");
    let varId = inputBox.dataset.varid;
    var errorEl = quantityContainer.closest('.cart-popup-product').querySelector('.error-quantity');
    const cartPopup = document.querySelector('#cart-popup');

    updateButtonStates(inputBox, minusBtn, plusBtn);
    quantityContainer.addEventListener("click", handleButtonClick);
    inputBox.addEventListener("input", handleQuantityChange);

    function updateButtonStates(inputBox, minusBtn, plusBtn) {
      var value = parseInt(inputBox.value);
      minusBtn.disabled = value <= 1;
      plusBtn.disabled = value >= parseInt(inputBox.max)
    }

    function handleButtonClick(event) {
      if (event.target.classList.contains("minus")) {
        decreaseValue()
      } else if (event.target.classList.contains("plus")) {
        increaseValue()
      }
    }

    function decreaseValue() {
      let value = parseInt(inputBox.value) || 1;
      const errorMessageProduct = document.querySelector('.product-form__error-message-wrapper');

      const min = 1;

      if (value <= min) return;

      value = Math.max(value - 1, min);
      inputBox.value = value;
      updateButtonStates(inputBox, minusBtn, plusBtn);
      errorEl.classList.add('d-none');
      updateCartBuble();

      setTimeout(() => {
        cartPopup.classList.add('loading');
        updateCart(varId, value, minusBtn);
        errorMessageProduct.classList.add('d-none');

      }, 300);
    }

    function increaseValue() {
      let value = parseInt(inputBox.value) || 1;
      const max = parseInt(inputBox.dataset.maxValue) || Infinity;

      if (value >= max) {
        errorEl.classList.remove('d-none');
        return;
      }

      value = Math.min(value + 1, max);
      inputBox.value = value;
      updateButtonStates(inputBox, minusBtn, plusBtn);
      errorEl.classList.add('d-none');
      updateCartBuble();

      setTimeout(() => {
        cartPopup.classList.add('loading');
        updateCart(varId, value, plusBtn);
      }, 300);
    }


    function handleQuantityChange() {
      var value = parseInt(inputBox.value);
      value = isNaN(value) ? 1 : value
    }
  })
}
